module.exports = __webpack_public_path__ + "img/es_mi_videostill.22387cdc.jpg";